//import Libraries
import React from 'react';
import PropTypes from 'prop-types'

//import Components


//import Style classes
// import './Fullpage.css';


const fullpage = (props) => {
    // console.log('[Fullpage.js]', props)
    let style = {
        width: "100%",
        boxSizing: "border-box",
        padding: props.padding ? props.padding : null,
        backgroundColor: props.backgroundColor ? props.backgroundColor : null,
        height: props.height ? props.height : "100vh"
    }
    let classNames = props.className ? props.className : "";
    return (
            <div id={props.id} className={'Fullpage '+classNames} style={style}>
                {props.children}
            </div>
    );
}

export default fullpage;

fullpage.propTypes= {
    padding : PropTypes.string,
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/hoc/Fullpage/Fullpage.js